import { useCallback, useContext, useEffect, useState } from 'react';
import { NavLink, Outlet, useNavigate, useParams } from 'react-router-dom';
import InstitutionTopCard from '../custom-components/InstitutionTopCard';
import LoadingBars from '../custom-components/LoadingBars';
import { getNavLinkClassName } from '../custom-components/SideNav';
import { GlobalContext } from '../global-context';
import { toastV4Error } from '../services/edulead-v4';
import { eduleadV4 } from '../services/edulead-v4-client';
import General from '../utils/GeneralUtils';
import { LegacyInstitution, toLegacyInstitution } from '../utils/legacyInstitution';
import { handleNewExport } from '../utils/newExportFeature';

export function InstitutionDetail(props: any) {

  const globalContext = useContext(GlobalContext);
  const navigate = useNavigate();

  const institution = globalContext.environment.entities.institution;

  const { id } = useParams()
  const [institutionId] = useState(id);

  const [response, setResponse] = useState<{ data: LegacyInstitution } | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isExportLoading, setIsExportLoading] = useState(false);

  // Handler for export button - exports this specific institution
  const handleExport = useCallback(async () => {
    setIsExportLoading(true);
    try {
      const exportId = await handleNewExport({
        type: 'selected',
        ids: [institutionId as string],
        entity: 'INSTITUTION',
        searchParams: {},
        estimatedCount: 1,
      });
      navigate(`/exports/${exportId}/target`);
    } finally {
      setIsExportLoading(false);
    }
  }, [institutionId, navigate]);

  async function loadInstitution() {
    try {
      setIsLoading(true)
      const got = await eduleadV4.institutions.get({ id: institutionId as string })
      const data = got.institution ? toLegacyInstitution(got.institution) : null
      setResponse(data && { data }); // the response structure the page kept before the Go API
      General.setTitle(document, data?.name ?? '', globalContext);
    } catch (err) {
      toastV4Error(err, 'Something went wrong loading institutions')
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    loadInstitution();
  }, [props.id]);

  return (
    <GlobalContext.Consumer>
      {(globalContextProps) =>
        <div style={{ paddingBottom: 100 }}>
          {
            !isLoading
              ? <>
                  {
                    (response)
                      ? <div className="content content-1000" style={{ paddingTop: 0, paddingBottom: 0 }}>
                          <InstitutionTopCard
                            institution={response.data}
                            onExport={handleExport}
                            isExportLoading={isExportLoading}
                          />
                        </div>
                      : <></>
                  }

                  <div className="content content-1000">
                    <div className="navigation-tabs">
                      <NavLink className={getNavLinkClassName} to={`/directory/institutions/${institutionId}/contacts`}>People</NavLink>
                      <NavLink className={getNavLinkClassName} to={`/directory/institutions/${institutionId}/schools`}>
                        {response?.data?.type === 'DISTRICT' ? 'Schools' : 'Child Institutions'}
                      </NavLink>
                    </div>
                  </div>

                  <Outlet />
                </>
              : <div className="content content-1000">
                  <LoadingBars numberOfRows={15} />
                </div>
          }
        </div>
      }
    </GlobalContext.Consumer>
  );
}
